<template>
    <div v-if="site" class="lm-border pa-3">
        <f-title :title="$t('invoice.contract.emc') + (collective ? ' (' + this.site.fabricNo + ')': '')"  />
        <v-row class="no-frame mt-0 pt-1 pb-1" >
            <v-col class="no-frame pr-2">
                <f-read-only-field
                    label        = "Gesamtkosten"
                    :value       = "contract.unit && contract.unit.costs ? toMoney(contract.unit.costs) : '---'"
                    :align-right = "true"
                    :collective  = "collective"
                    :filled      = "!collective"
                    dense
                />
            </v-col>
            <v-col class="no-frame pr-2">
                <f-read-only-field
                    label        = "Miete pro Jahr"
                    :value       = "contract.unit && contract.unit.rent ? toMoney(contract.unit.rent) : '---'"
                    :align-right = "true"
                    :collective  = "collective"
                    :filled      = "!collective"
                    dense
                />
            </v-col>
            <v-col class="no-frame pl-2 white">
                <f-read-only-field
                    label        = "Bereitschaft pro Jahr"
                    :value       = "contract.unit && contract.unit.standBy ? toMoney(contract.unit.standBy) : '---'"
                    :align-right = "true"
                    :collective  = "collective"
                    :filled      = "!collective"
                    dense
                />
            </v-col>
        </v-row>
        <v-row class="no-frame mt-0 mt-3" >
            <v-col class="no-frame pr-2 pt-1">
                <f-read-only-field
                    label        = "Telefonkosten"
                    :value       = "contract.unit && contract.unit.phoneCosts ? toMoney(contract.unit.phoneCosts) : '---'"
                    :align-right = "true"
                    :collective  = "collective"
                    :filled      = "!collective"
                    dense
                />
            </v-col>
            <v-col class="no-frame pl-2 white pb-2 pt-1">
                <f-read-only-field
                    label        = "Aufzugswärter"
                    :value       = "contract.unit && contract.unit.guardCosts ? toMoney(contract.unit.guardCosts) : '---'"
                    :align-right = "true"
                    :collective  = "collective"
                    :filled      = "!collective"
                    dense
                />
            </v-col>
            <v-col class="no-frame pl-2 white pb-2 pt-1">
            </v-col>
        </v-row>
    </div>
</template>

<script>
import FTitle         from "@/modules/core/components/utils/FTitle";
import Core           from "@/modules/core/service/Core";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField";

export default {
    name: "CContractEscAbstract",

    components: {
        FReadOnlyField,
        FTitle
    },

    props: {
        collective: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },
    },

    computed: {
        site () {
            return this.$store.getters.site;
        },

        contract () {
            return this.site["liftmanagement"]["escContract"];
        }
    },

    methods: {
        toMoney (number) {
            return Core.format.money (number);
        },
    }
}
</script>

<style scoped>

</style>